import { BTN_LIST_OPTION } from '../../renderOption';
import { BTN_MAP_KEY } from '../../enums/index';

/**
 * 初始化data数据
 * @returns 
 */
function getDefaultData () {
  return {
    content: null,
    isCanDraw: false, // 是否可绘制
    isCanEdit: false, // 是否可编辑
    handlerBack: null,
    addLamp: null,
    btnMap: new Map()
  }
}

const BTN_CLASSNAME = 'draw-canvas_btn';

/**
 * 按钮组件
 */
class BtnList {
  constructor(props) {
    const data = props || {};

    this.init(data);
  }

  data = getDefaultData();

  async init(props) {
    this.data = {
      ...this.data,
      ...props
    }
    this.createBtnList();
  }

  getData() {
    return this.data;
  }

  // 创建按钮列表
  createBtnList() {
    const { draw, edit, delete: delConfig, deleteLast } = this.data.btnConfig || {};
    const btnList = document.createElement('div');
    const btnContainer = document.createElement('div');
    const btnStyle = document.createElement('style');

    btnList.className = 'draw-canvas_btn-list';
    btnContainer.className = 'draw-canvas_btn-list_container'
    btnStyle.innerHTML = BTN_LIST_OPTION.css;

    // 按钮配置
    const drawConfig = this.mergeBtnConfig(
      draw, BTN_LIST_OPTION.draw, BTN_MAP_KEY.DRAW, () => this.setIsCanDraw()
    );
    const editConfig = this.mergeBtnConfig(
      edit, BTN_LIST_OPTION.edit, BTN_MAP_KEY.EDIT, () => this.setIsCanEdit()
    );
    const deleteConfig = this.mergeBtnConfig(
      delConfig, BTN_LIST_OPTION.delete, BTN_MAP_KEY.DELETE, () => this.handlerDelete()
    );
    const deleteLastConfig = this.mergeBtnConfig(
      deleteLast, BTN_LIST_OPTION.deleteLast, BTN_MAP_KEY.DELETE_LAST, () => this.handlerDeleteLast()
    );

    // 创建按钮
    [drawConfig, editConfig, deleteConfig, deleteLastConfig].forEach(config => {
      config.isShow && this.createBtn(config, btnContainer);
    })
    

    btnList.appendChild(btnContainer);
    document.head.appendChild(btnStyle);
    this.data.content.appendChild(btnList);
  }

  // 混合按钮配置
  mergeBtnConfig(config = {}, defaultConfig, btnKey, fn) {
    return {
      ...defaultConfig,
      ...config,
      fn,
      btnKey
    }
  }

  // 创建按钮
  createBtn(config, btnContainer) {
    const btn = document.createElement('div');

    btn.className = BTN_CLASSNAME;
    btn.innerHTML = `<p>${config.text}</p>`;
  
    this.data.btnMap.set(config.btnKey, btn);

    if (config.icon) {
      btn.innerHTML = `<i class="${config.icon}"></i>` + btn.innerHTML
    }

    btn.addEventListener('click', () => {
      // 点击事件
      if (config.onclick instanceof Function)  config.onclick();

      config.fn();

      // 回调事件
      if (config.callBack instanceof Function)  config.callBack();
    });

    btnContainer.appendChild(btn);
  }

  // 设置是否可以绘制
  setIsCanDraw = (boolean) => {
    const btnMap = this.data.btnMap;
    const isActive = boolean === void 0 ? !this.data.isCanDraw : boolean;

    btnMap.get(BTN_MAP_KEY.DRAW).className = isActive ? `${BTN_CLASSNAME} active` : BTN_CLASSNAME;
  
    this.data.isCanDraw = isActive;

    if (isActive) { 
      btnMap.get(BTN_MAP_KEY.EDIT).className = BTN_CLASSNAME;
      
      this.data.isCanEdit = false;
    }
  }

  // 设置是否可以编辑
  setIsCanEdit  = (boolean) => {
    const btnMap = this.data.btnMap;
    const isActive = boolean === void 0 ? !this.data.isCanEdit : boolean;
    
    btnMap.get(BTN_MAP_KEY.EDIT).className =  isActive ? `${BTN_CLASSNAME} active` : BTN_CLASSNAME;

    this.data.isCanEdit = isActive;

    if (isActive) {
      btnMap.get(BTN_MAP_KEY.DRAW).className = BTN_CLASSNAME;
      this.data.isCanDraw = false;
    }
  }

  // 删除
  handlerDelete = () => {
    this.data.handlerDelete && this.data.handlerDelete()
  }

  // 删除最后一根
  handlerDeleteLast = () => {
    this.data.handlerDeleteLast && this.data.handlerDeleteLast();
  }

  // 增加灯
  addLamp = () => {
    this.data.addLamp && this.data.addLamp()
  }

  $emit = () => {

  }
}

export default BtnList;